import { HomePicturePage } from './HomePicturePage';
export default HomePicturePage;
